import {slider} from "../modules/slider";
import {nav} from "../modules/nav";
import {player} from "../modules/player";
import {maps} from "../modules/maps";
import {form} from "../modules/form";
import {tabs} from "../modules/tabs";
import {toggle} from "../modules/toggle";

import SVGInjector from "svg-injector";
import ShareButton from "share-button/dist/share-button";
import ScrollReveal from "scrollreveal";
import "image-scale/image-scale";
import "fluidbox";

/**
 * Common
 */
export default () => {

    nav.init();
    slider.init();
    player.init();
    maps.init();
    form.init();
    tabs.init();
    toggle.init();

  /**
   * Inject SVGs
   */
    let SVGs = document.querySelectorAll('img.svg');
    new SVGInjector(SVGs, {
        evalScripts: 'once',
    }, function () {
      //
    });

    /**
     * Wall of Wonders Teaser: Fire Scroll Reveal Animations (set in the footer)
     */
    const sr = new ScrollReveal();

    const teaserBox = {
        delay    : 700,
        origin   : 'bottom',
        distance : '120px',
        easing   : 'ease-in-out',
        scale    : 1.1,
        reset: true,
    };

    const wowImg = {
        delay    : 400,
        origin   : 'left',
        distance : '100px',
        easing   : 'ease-in-out',
        rotate   : { z: -10 },
        scale    : 1.1,
        reset: true,
    };

    if ( $("#wow_teaser").length ) {
        sr.reveal('.wow_teaser .teaser-box', teaserBox);
        sr.reveal('.wow_teaser .upload-img', wowImg);
    }


  /**
   * Fluidbox: Lightbox Effect for images
   */
    $('article a:has(img)').fluidbox({
        immediateOpen: false,
        loader: true,
    });

  /**
   * Wonders Play Cards Slider
   * On before slide change
   */
  $('.header-wonder-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      const $jumbotron = $('.image-header .jumbotron');

      $jumbotron.find('#wonder_img_' + currentSlide).removeClass('active');
      $jumbotron.find('#wonder_img_' + nextSlide).addClass('active');
  });

  $('[id^=wonder-details-]').on('shown.bs.collapse', function () {
      $(this).find('.media-slider-compact').slick('reinit');
  });


  /**
   * Scale Images
   */
  $(function () {
    $("img.scale").imageScale({
        rescaleOnResize: true,
        didScale: function (firstTime) {
            if (firstTime) {
                $(this.element).css('opacity', '1');
            }
        },
    });
  });


  /**
   * Image Scroll Effect
   */
  $(window).scroll(function () {
    // Add parallax scrolling to all images in .teaser-container container
    $('.teaser-container').each(function () {
      // only put top value if the window scroll has gone beyond the top of the image
        const start = $(this).offset().top - $(window).height();

        if ( start < $(window).scrollTop() ) {
          // Get amount of pixels the image is above the top of the window
            let difference = $(window).scrollTop() - $(this).offset().top + $(window).height();
          // Top value of image is set to half the amount scrolled
          // (this gives the illusion of the image scrolling slower than the rest of the page)
            let fourth = ( difference / 4 ) + 'px';

          // $(this).find('img.wonder-bg').css('top', sixth);
            $(this).find('img.upload-img').css('top', fourth);
        } else {
          // if image is below the top of the window set top to 0
            $(this).find('img.upload-img').css('top', '50%');
        }
    });
  });

  /**
   * Share Buttons
   */
  new ShareButton({
        ui: {
            flyout: 'middle left',
            button_font: false,
            buttonText: '',
            icon_font: true,
        },
        networks: {
            reddit: {
                enabled: false,
            },
            linkedin: {
                enabled: false,
            },
            facebook: {
                enabled: true,
                appId: '140947317372',
            },
        },
    });
};
